import { render, staticRenderFns } from "./PerformanceSummary.vue?vue&type=template&id=7cf308b2&scoped=true"
import script from "./PerformanceSummary.vue?vue&type=script&lang=js"
export * from "./PerformanceSummary.vue?vue&type=script&lang=js"
import style0 from "./PerformanceSummary.vue?vue&type=style&index=0&id=7cf308b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf308b2",
  null
  
)

export default component.exports